import React from "react";
import styled from "styled-components";

const Bloomberg = styled.div`
    font-weight: bold;
    font-size: 16px;
`;

const Name = styled.h1`
    font-size: 26px;
    font-weight: bold;
    line-height: 1.2;
    margin: 0;
`;

export const StockPageTitle = ({bloomberg, name}) => {
    return <div>
        <Bloomberg className="t-bloomberg">{bloomberg}</Bloomberg>
        <Name className="t-name">{name}</Name>
    </div>
};